module.exports = __webpack_public_path__ + "static/media/confetti.067f3e34.gif";